import { mockAppAPI } from './api-app';

export default [...mockAppAPI];
